import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';
import BaseUrl from '../../../assets/utils/accessToken'
const initialState = {

  UtilizedConfigs: [],
  UtilizedConfigsStatus: 'idle',
  UtilizedConfigsByType: [],
  UtilizedConfigsByTypeStatus: 'idle',
  UtilizedConfig: null,
  UtilizedConfigStatus: 'idle',

}

export const fetchUtilizedConfigs = createAsyncThunk('utilizedConfig/fetchUtilizedConfigs', async (id, { rejectWithValue }) => {
  try {

    const token = localStorage.getItem('token')
    const response = await axios.get(BaseUrl + '/utilizedResearchLabsConfig/',
      {
        headers: {
          'Authorization': `Token ${token}`
        }
      }

    )
    //console.log(response.data, 'response.data')
    return response.data

  } catch (err) {
    let error = err
    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response)
  }
})

export const addUtilizedConfig = createAsyncThunk(
  'utilizedConfig/addUtilizedConfig',
  async (toAddActivity, { rejectWithValue }) => {

    try {
      const token = localStorage.getItem('token')
      const response = await axios.post(BaseUrl + `/utilizedResearchLabsConfig/create/`, toAddActivity, {
        headers: {
          'Authorization': `token ${token}`
        }
      })
      return response.data
    } catch (err) {
      let error = err
      if (!error.response) {
        throw err
      }

      return rejectWithValue(error.response)
    }
  }
)

export const deleteUtilizedConfig = createAsyncThunk(
  'utilizedConfig/deleteUtilizedConfig',
  async (id, { rejectWithValue }) => {

    try {
      const token = localStorage.getItem('token')
      const response = await axios.delete(BaseUrl + `/utilizedResearchLabsConfig/${id}/delete/`, {
        headers: {
          'Authorization': `token ${token}`
        }
      })
      return response.data
    } catch (err) {
      let error = err
      if (!error.response) {
        throw err
      }

      return rejectWithValue(error.response)
    }
  }
)

const utilizedConfigSlice = createSlice({
  name: 'utilizedConfig',
  initialState,
  extraReducers: {

    [fetchUtilizedConfigs.pending]: (state, action) => {
      state.UtilizedConfigsStatus = 'loading'
    },
    [fetchUtilizedConfigs.fulfilled]: (state, action) => {
      state.UtilizedConfigsStatus = 'succeeded'

      state.UtilizedConfigs = action.payload
    },
    [fetchUtilizedConfigs.rejected]: (state, action) => {
      state.UtilizedConfigsStatus = 'failed'
      if (action.payload) {
        state.error = action.payload
      } else {
        state.error = action.error
      }
    },

  },

})

export default utilizedConfigSlice.reducer

